"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toInt = exports.currencyNumberDisplay = exports.formatThousands = void 0;
function isNumber(value) {
    if (typeof value !== 'number')
        return false;
    if (typeof value === 'undefined' || value === null)
        return false;
    if (isNaN(value))
        return false;
    if (value === 'NaN')
        return false;
    // if(`${+value}` !== value as unknown as string) return false
    return true;
}
/**
 * Format big numbers, i.e. thousands,
 * millions and billions - e.g. turn 3,523,123 into 3.5M.
 * @param numValue
 * @param opts.compact - Whether to use compact notation, e.g.
 * 3.5M instead of 3,500,000. (true by default)
 * @param opts.places - The number of decimal places to use.
 * (2 by default)
 * @param opts.currencyCode - The currency code to use, e.g.
 * "USD". (empty string by default)
 * @returns A formatted numeric value, e.g.
 *  5,230 becomes 5K, or 5,2K when `place = 1`.
 */
function formatThousands(numValue, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.compact, compact = _c === void 0 ? true : _c, _d = _b.places, places = _d === void 0 ? 2 : _d, _e = _b.currencyCode, currencyCode = _e === void 0 ? '' : _e;
    if (!isNumber(numValue))
        return '-';
    return Intl.NumberFormat(undefined, // Use the user's locale
    {
        notation: compact ? 'compact' : 'standard',
        maximumFractionDigits: places,
        style: currencyCode ? 'currency' : 'decimal',
        currency: currencyCode ? currencyCode : undefined
    }).format(numValue);
}
exports.formatThousands = formatThousands;
/**
 * Turns a value with type `number` into a string with the requested currency..
 * @param value
 * @param currencyCode
 * @param opts.useBracketsForNegative - Whether to use brackets for negative values.
 * @param opts.compact - Whether to use compact notation, e.g.
 * 3.5M instead of 3,500,000. (true by default)
 * @param opts.places - The number of decimal places to use.
 * (2 by default)
 * @param opts.currencyCode - The currency code to use, e.g.
 * "USD". (empty string by default)
 * @returns The value stringified. In brackets if negative, a hyphen if 0.
 */
function currencyNumberDisplay(value, currencyCode, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.useBracketsForNegative, useBracketsForNegative = _c === void 0 ? true : _c, _d = _b.compact, compact = _d === void 0 ? true : _d, _e = _b.places, places = _e === void 0 ? 2 : _e;
    if (!isNumber(value))
        return '-';
    if (value === 0)
        return '-';
    if (useBracketsForNegative)
        value = Math.abs(value);
    var formattedValue = formatThousands(value, {
        compact: compact,
        places: places,
        currencyCode: currencyCode
    });
    if (!useBracketsForNegative)
        return formattedValue;
    return value < 0 ? "(".concat(formattedValue, ")") : formattedValue;
}
exports.currencyNumberDisplay = currencyNumberDisplay;
/**
 * @param value The value to be parsed.
 * @returns A valid number or `undefined`.
 */
function toInt(value) {
    if (Number.isNaN(value))
        return undefined;
    if (typeof value === 'number')
        return value;
    if (typeof value !== 'string')
        return undefined;
    var int = parseInt(value, 10);
    if (Number.isNaN(value))
        return undefined;
    if ("".concat(int).length !== value.length)
        return undefined;
    return int;
}
exports.toInt = toInt;
